<template>
  <el-dialog
  :title="popTitle"
  :visible.sync="visibleDialog"
  width="424px"
  top="calc(50vh - 140px)"
  class="pop-dialog pop-set-tag"
  append-to-body>
  <el-radio-group  v-model="radio" class="radio-group">
    <el-radio v-for="(item,index) of radioList" :label="item.tagId" @click.native.prevent="changeTag(item.tagId)" :key="index"><span :class="'tag-no tag-'+item.tagId"></span></el-radio>
  </el-radio-group>
   <el-checkbox-group v-model="check" class="checkbox-group">
    <el-checkbox  v-for="(item,index) of checkList" :label="item.tagId" :key="index">{{item.tagName}}<span v-if="item.tagOrderType==2" class="i-yichang"></span></el-checkbox >
  </el-checkbox-group>
  <template slot="footer">
    <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="onConfirm" size="mini">确 定</el-button>
  </template>
</el-dialog>
</template>
<script>

  export default {
    name:'popSetTag',
    data () {
      return {
        visibleDialog:false,
        radio:'',
        check:[],
        type:'',
        popTitle:'选择标签'
      }
    },
    computed: {
      radioList() {
        return this.$parent.flagTags
      },
      checkList() {
        return this.$parent.textTags
      }
    },

    methods: {
      // 单选
      changeTag(id) {
        this.radio = this.radio === id ? '' : id; 
      },
       // 批量设置不需要回显
      show(data) {
        console.log('show:',data)
        if (typeof data === 'object') {
          this.radio = data.radio
          this.check = data.check
        }else {
          this.radio = ''
          this.check = []
        }
        if (data.type) {
          this.type = data.type
          if (this.type ==='includeTag') {
            this.popTitle = '包含标签'
          }else if (this.type ==='excludeTag') {
            this.popTitle = '排除标签'
          }
        }else{
          this.popTitle = '选择标签'
        }
        this.visibleDialog = true
      },
      // 确认修改
      onConfirm() {
        let data = {
          tagIds:[this.radio,...this.check],
        }
        data.tagIds = data.tagIds.filter(item => item)
        if(this.type ==='includeTag' || this.type ==='excludeTag'){
          data.radio = this.radio || ''
          data.check = this.check
          data.type = this.type
          this.$bus.$emit('hasSelectTag',data)
        }else{
          // if (!this.radio && this.check.length === 0) {
          //   this.$message.warning('请选择标签')
          //   return
          // }
          
         this.$emit('hasSetTag',data)
        }
        console.log('>>',data)
        // return false
        this.visibleDialog = false
      },
    },
  }
</script>
<style lang='scss'>
.pop-set-tag{
  .el-radio .el-radio__inner{
    box-shadow: none!important;
  }
  .radio-group{
    display: flex;
    padding: 18px 0 30px;
  }
  .el-radio{
    display: flex;
    align-items: center;
    margin-right: 12px;
    .el-radio__label{
      padding-left: 3px;
    }
  }
 .tag-no{
  border: none;
 }
 .checkbox-group{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 19px;
  }
  .el-checkbox{
    width: 33.3%;
    margin-right: 0;
    margin-bottom: 15px;
    .el-checkbox__label{
      padding-left: 5px;
      font-weight: normal;
      font-size: 12px;
      color: #333;
    }
  }
  .i-yichang{
    width: 12px;
    height: 12px;
    display: inline-block;
    background: url('~@/assets/sale/yichang.png');
    vertical-align: middle;
    margin-left: 2px;
  }
}
</style>